import { render } from "./BootsrapperVersion.vue?vue&type=template&id=1e854f86"
import script from "./BootsrapperVersion.vue?vue&type=script&lang=js"
export * from "./BootsrapperVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__